import { decode } from 'html-entities';

/**
 * Strips HTML tags, decodes entities, and normalises whitespace for search matching.
 * Used consistently across API search, offline global search, and in-document search.
 */
export const stripHtmlTags = (html: string): string => {
  return decode(html.replace(/<[^>]+>/g, ' '))
    .replace(/\s+/g, ' ')
    .trim();
};
